import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Address, PostcodesIO, Country } from 'models';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AddressService {
    constructor(private http: HttpClient) {}

    public lookupPostcode(postcode: string): Observable<Address[]> {
        return this.http.post<Address[]>('api/address/lookuppostcode', postcode).pipe(
            map((addresses: Address[]) => {
                return addresses.map(address => {
                    // Trimming spaces
                    Object.keys(address).map(key => {
                        address[key] = typeof address[key] === 'string' ? address[key].trim() : '';
                    });
                    return address;
                });
            })
        );
    }

    public getCountries(): Observable<Country[]> {
        return this.http.get<Country[]>('api/address/countries');
    }

    public postcodeCoordinates(postcode: string): Observable<PostcodesIO.ResponseResult> {
        return this.http
            .get<PostcodesIO.Response>(`https://api.postcodes.io/postcodes/${postcode}`)
            .pipe(map(response => response.result));
    }
}
